export default {
  reviewStatistics: "dashboard/REVIEW_CU/getReviewStatistics",
  dateStatistics: "dashboard/REVIEW_CU/getDateStatistics",
  reviewLogs: "dashboard/reviewLogs",
};
